
import { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-stone-200 overflow-hidden">
        <div className="p-6 md:p-8">
          <div className="flex flex-col md:flex-row md:items-center gap-6">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-full">
                  <i className="ri-cookie-line text-xl text-amber-600"></i>
                </div>
                <h3 className="text-lg font-semibold text-stone-800">Cookie Notice</h3>
              </div>
              <p className="text-sm text-stone-600 leading-relaxed">
                We use cookies to enhance your browsing experience, analyse site traffic, and personalise content. 
                By clicking "Accept All", you consent to our use of cookies in accordance with our{' '}
                <a href="/privacy" className="text-amber-600 hover:text-amber-700 underline cursor-pointer">
                  Privacy Policy
                </a>.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 md:flex-shrink-0">
              <button
                onClick={handleDecline}
                className="px-6 py-3 text-sm font-medium text-stone-600 bg-stone-100 hover:bg-stone-200 rounded-full transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                Decline
              </button>
              <button
                onClick={handleAccept}
                className="px-6 py-3 text-sm font-medium text-white bg-amber-600 hover:bg-amber-700 rounded-full transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                Accept All
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
